<template>
  <el-tabs v-model="activeName" type="border-card">
    <el-tab-pane label="清单列表" name="first">
      <div class="main">
        <!-- Right -->
        <div class="main_r">
          <!-- search -->
          <div class="search">
            <div>
              <el-select v-model="gvtype" placeholder="字典分类">
                <el-option v-for="item in gvTypeList" :label="item" :value="item"></el-option>
              </el-select>
              <el-input v-model="name"  placeholder="请输入字典名称"></el-input>
              <el-input v-model="gv"  placeholder="请输入字典数据"></el-input>
              <el-button type="primary" @click="clickQuery">查询</el-button>
              <el-button type="primary" @click="clickQueryReset" plain>重置</el-button>
              <el-button type="primary" icon="el-icon-plus" @click="clickAdd">新增</el-button>
            </div>
          </div>
          <!-- search End -->

          <!-- 列表 -->
          <el-table :data="dataList" ref="projecttable" style="width: 100%" class="tableOut" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }" @sort-change="handleSortChange">
            <el-table-column prop="id" label="序号" width="80" sortable="custom"></el-table-column>
            <el-table-column prop="sortOrder" label="排序" width="80" sortable="custom"></el-table-column>
            <el-table-column prop="type" label="字典分类" width="150" sortable="custom"></el-table-column>
            <el-table-column prop="name" label="字典名称" width="150" sortable="custom"></el-table-column>
            <el-table-column prop="gv" label="字典数据主" sortable="custom"></el-table-column>
            <el-table-column prop="gv2" label="字典数据副" sortable="custom"></el-table-column>
            <el-table-column label="更新模式" width="100">
              <template v-slot="scope">
                <el-tag v-if="scope.row.gv3 === 'forced'" type="danger" size="small">强制更新</el-tag>
                <el-tag v-else-if="scope.row.gv3 === 'optional'" type="success" size="small">可选更新</el-tag>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="note" label="字典备注" sortable="custom"></el-table-column>
            <el-table-column label="英文名称" min-width="120">
              <template v-slot="scope">
                <span>{{ (translationMap[scope.row.id] && translationMap[scope.row.id]['en'] && translationMap[scope.row.id]['en']['name']) || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="德文名称" min-width="120">
              <template v-slot="scope">
                <span>{{ (translationMap[scope.row.id] && translationMap[scope.row.id]['de'] && translationMap[scope.row.id]['de']['name']) || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="Operation" label="操作" width="240">
              <template v-slot="scope">
                <el-tooltip class="item" effect="dark" content="详情" placement="top" :enterable="false">
                  <el-link :underline="false" type="primary" icon="el-icon-view" class="mr12" @click="clickDetail(scope.row)"></el-link>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="编辑" placement="top" :enterable="false">
                  <el-link :underline="false" type="primary" icon="el-icon-edit" class="mr12" @click="clickEdit(scope.row)"></el-link>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="编辑富文本" placement="top" :enterable="false">
                  <el-link :underline="false" type="primary" icon="el-icon-info" class="mr12" @click="clickUeditor(scope.row)"></el-link>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="翻译" placement="top" :enterable="false">
                  <el-link :underline="false" type="primary" icon="el-icon-s-opportunity" class="mr12" @click="clickI18n(scope.row)"></el-link>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="上移" placement="top" :enterable="false">
                  <el-link :underline="false" type="primary" icon="el-icon-top" class="mr12" @click="clickMoveUp(scope.$index, scope.row)"></el-link>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="下移" placement="top" :enterable="false">
                  <el-link :underline="false" type="primary" icon="el-icon-bottom" class="mr12" @click="clickMoveDown(scope.$index, scope.row)"></el-link>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="top" :enterable="false">
                  <el-link :underline="false" type="danger" icon="el-icon-circle-close" class="mr12" @click="clickDelete(scope.row)"></el-link>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <div class="mt20">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20]"
              :page-size="pageSize"
              layout="prev, pager, next, sizes, jumper "
              :total="dataListnum">
            </el-pagination>
          </div>
          <!-- 分页 End -->
        </div>
        <!-- Right End -->

        <!---------------------- 以下是一级Table弹框内容 ---------------------->
        <!-- 编辑信息 -->
        <el-dialog title="编辑信息" :visible.sync="dialogEdit" class="newAdd" :close-on-click-modal="false">
          <el-form :model="editForm">
            <el-form-item label="字典分类" :label-width="formLabelWidth" :required=true>
              <el-input v-model="editForm.type" autocomplete="off" placeholder="请输入字典分类"></el-input>
            </el-form-item>
            <el-form-item label="字典名称" :label-width="formLabelWidth" :required=true>
              <el-input v-model="editForm.name" autocomplete="off" placeholder="请输入字典名称"></el-input>
            </el-form-item>
            <el-form-item label="字典数据主" :label-width="formLabelWidth" :required=true>
              <el-input v-model="editForm.gv" autocomplete="off" placeholder="请输入字典数据主"></el-input>
            </el-form-item>
            <el-form-item label="字典数据副" :label-width="formLabelWidth">
              <el-input v-model="editForm.gv2" autocomplete="off" placeholder="请输入字典数据副"></el-input>
            </el-form-item>
            <el-form-item label="字典备注" :label-width="formLabelWidth">
              <el-input type="textarea" v-model="editForm.note" autocomplete="off" placeholder="请输入字典备注"></el-input>
            </el-form-item>
            <el-form-item label="排序序号" :label-width="formLabelWidth">
              <el-input-number v-model="editForm.sortOrder" :min="1" controls-position="right"></el-input-number>
            </el-form-item>
            <el-form-item label="更新模式" :label-width="formLabelWidth"
              v-if="editForm.type === 'APP更新' || editForm.type === '固件更新'">
              <el-select v-model="editForm.gv3" placeholder="请选择更新模式">
                <el-option label="可选更新" value="optional"></el-option>
                <el-option label="强制更新" value="forced"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="GvUpdate(1)">确 认</el-button>
            <el-button @click="dialogEdit = false">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 编辑信息 End -->

        <!-- 详情信息 -->
        <el-dialog title="详情信息" :visible.sync="dialogDetail" class="newAdd detailDialog" :close-on-click-modal="false">
          <el-form :model="detailForm">
            <el-form-item label="字典分类" :label-width="formLabelWidth">
              <div class="detailText">{{ detailForm.type || '-' }}</div>
            </el-form-item>
            <el-form-item label="字典名称" :label-width="formLabelWidth">
              <div class="detailText">{{ detailForm.name || '-' }}</div>
            </el-form-item>
            <el-form-item label="字典数据主" :label-width="formLabelWidth">
              <div class="detailText detailTextArea">{{ detailForm.gv || '-' }}</div>
            </el-form-item>
            <el-form-item label="字典数据副" :label-width="formLabelWidth">
              <div class="detailText">{{ detailForm.gv2 || '-' }}</div>
            </el-form-item>
            <el-form-item label="字典备注" :label-width="formLabelWidth">
              <div class="detailText detailTextArea">{{ detailForm.note || '-' }}</div>
            </el-form-item>
            <el-form-item label="更新模式" :label-width="formLabelWidth">
              <div class="detailText">{{ detailForm.gv3 === 'forced' ? '强制更新' : detailForm.gv3 === 'optional' ? '可选更新' : '-' }}</div>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogDetail = false">关 闭</el-button>
          </div>
        </el-dialog>
        <!-- 详情信息 End -->

        <!-- 新增信息 -->
        <el-dialog title="新增信息" :visible.sync="dialogAdd" class="newAdd" :close-on-click-modal="false">
          <el-form :model="addForm">
            <el-form-item label="字典分类" :label-width="formLabelWidth" :required=true>
              <el-select v-model="addForm.type" placeholder="请选择字典分类" style="width: 100%">
                <el-option v-for="item in gvTypeList" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="字典名称" :label-width="formLabelWidth" :required=true>
              <el-input v-model="addForm.name" autocomplete="off" placeholder="请输入字典名称"></el-input>
            </el-form-item>
            <el-form-item label="字典数据主" :label-width="formLabelWidth" :required=true>
              <el-input v-model="addForm.gv" autocomplete="off" placeholder="请输入字典数据主"></el-input>
            </el-form-item>
            <el-form-item label="字典数据副" :label-width="formLabelWidth">
              <el-input v-model="addForm.gv2" autocomplete="off" placeholder="请输入字典数据副"></el-input>
            </el-form-item>
            <el-form-item label="字典备注" :label-width="formLabelWidth">
              <el-input type="textarea" v-model="addForm.note" autocomplete="off" placeholder="请输入字典备注"></el-input>
            </el-form-item>
            <el-form-item label="更新模式" :label-width="formLabelWidth"
              v-if="addForm.type === 'APP更新' || addForm.type === '固件更新'">
              <el-select v-model="addForm.gv3" placeholder="请选择更新模式">
                <el-option label="可选更新" value="optional"></el-option>
                <el-option label="强制更新" value="forced"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="GvInsert()">确 认</el-button>
            <el-button @click="dialogAdd = false">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 新增信息 End -->

        <!-- 翻译管理 -->
        <i18n-translation-dialog
          :visible.sync="dialogI18n"
          :entity-type="i18nEntityType"
          :entity-id="i18nEntityId"
          :fields="i18nFields">
        </i18n-translation-dialog>
        <!-- 翻译管理 End -->

      </div>
    </el-tab-pane>

    <el-tab-pane label="编辑富文本" name="second" disabled="disabled">
      <VueUeditorWrap v-model="ueditorContent" :config="myConfig"></VueUeditorWrap>
      <el-button type="primary" @click="GvUpdate(2)" >保 存</el-button>
      <el-button @click="GoBack()">返 回</el-button>
    </el-tab-pane>

  </el-tabs>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import I18nTranslationDialog from '@/components/I18nTranslationDialog.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    VueUeditorWrap,
    I18nTranslationDialog
  },
  data () {
    return {
      activeName: 'first',
      formLabelWidth: '120px',
      selectParentId: '',
      gvTypeList: [],
      gvtype: '固件更新',
      name: '',
      gv: '',
      dataList: [],
      dataListnum: 0,
      pageNo: 1,
      pageSize: 5,
      sortField: '',
      sortOrder: '',
      editForm: {
        id: '',
        type: '',
        name: '',
        gv: '',
        gv2: '',
        gv3: '',
        note: '',
        sortOrder: ''
      },
      detailForm: {
        id: '',
        type: '',
        name: '',
        gv: '',
        gv2: '',
        gv3: '',
        note: ''
      },
      ueditorContent:'',
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 500,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口
        serverUrl: '',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/UEditor/'
      },
      currentPage: 0,
      dialogEdit: false,
      dialogDetail: false,
      dialogAdd: false,
      addForm: {
        type: '',
        name: '',
        gv: '',
        gv2: '',
        gv3: '',
        note: ''
      },
      // 翻译管理
      dialogI18n: false,
      i18nEntityId: null,
      i18nEntityType: 'GV',
      i18nFields: [
        { name: 'name', label: '字典名称', type: 'input' }
      ],
      translationMap: {}
    }
  },
  watch: {
    dialogI18n(val) {
      if (!val) {
        this.loadTranslations('GV', this.dataList, 'id')
      }
    }
  },
  mounted () {
    console.log(localStorage.getItem('gvTypeList'))
    this.gvTypeList = localStorage.getItem('gvTypeList').split(",");
    console.log(this.gvTypeList)
    this.GvList()
    this.GvNum()
  },
  methods: {
    handleSizeChange (val) {
      this.pageSize = val
      this.GvList()
      this.GvNum()
    },
    handleCurrentChange (val) {
      this.pageNo = val
      this.GvList()
      this.GvNum()
    },
    handleSortChange ({ prop, order }) {
      this.sortField = prop || ''
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.pageNo = 1
      this.GvList()
      this.GvNum()
    },
    clickQuery () {
      this.GvList()
      this.GvNum()
    },
    clickQueryReset () {
      this.name = ''
      this.gv = ''
      this.GvList()
      this.GvNum()
    },
    clickAdd () {
      this.dialogAdd = true
      this.addForm.type = this.gvtype
      this.addForm.name = ''
      this.addForm.gv = ''
      this.addForm.gv2 = ''
      this.addForm.gv3 = ''
      this.addForm.note = ''
    },
    clickI18n (row) {
      this.i18nEntityId = row.id
      // 根据 GV 的 name 判断是否为需要翻译内容的类型（协议/政策/须知）
      if (row.name && (row.name.indexOf('协议') !== -1 || row.name.indexOf('政策') !== -1 || row.name.indexOf('须知') !== -1)) {
        this.i18nFields = [
          { name: 'name', label: '字典名称', type: 'input' },
          { name: 'gv', label: '内容', type: 'textarea' }
        ]
      } else {
        this.i18nFields = [
          { name: 'name', label: '字典名称', type: 'input' }
        ]
      }
      this.dialogI18n = true
    },
    clickEdit (row) {
      this.dialogEdit = true
      this.editForm.id = row.id
      this.editForm.type = row.type
      this.editForm.name = row.name
      this.editForm.gv = row.gv
      this.editForm.gv2 = row.gv2
      this.editForm.gv3 = row.gv3
      this.editForm.note = row.note
      this.editForm.sortOrder = row.sortOrder
    },
    clickDetail (row) {
      this.dialogDetail = true
      this.detailForm.id = row.id
      this.detailForm.type = row.type
      this.detailForm.name = row.name
      this.detailForm.gv = row.gv
      this.detailForm.gv2 = row.gv2
      this.detailForm.gv3 = row.gv3
      this.detailForm.note = row.note
    },
    clickUeditor(row){
      this.activeName = 'second'
      this.editForm.id = row.id
      this.editForm.type = row.type
      this.editForm.name = row.name
      this.editForm.gv = row.gv
      this.editForm.gv2 = row.gv2
      this.editForm.gv3 = row.gv3
      this.editForm.note = row.note
      this.ueditorContent = row.gv
      this.editForm.gv3 = row.gv3
    },
    GoBack(){
      this.activeName = 'first'
    },
    GvList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.parentId = that.selectParentId
      data.type = that.gvtype
      data.name = that.name
      data.gv = that.gv
      data.pageNo = that.pageNo
      data.pageSize = that.pageSize
      data.sortField = that.sortField
      data.sortOrder = that.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_GvList, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataList = response.data.data
            that.loadTranslations('GV', that.dataList, 'id')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadTranslations: function (entityType, list, idField) {
      var that = this
      if (!list || list.length === 0) {
        that.translationMap = {}
        return
      }
      var ids = list.map(function(item) { return item[idField] }).join(',')
      var data = Vue.prototype.FunGetBaseSignData()
      data.entityType = entityType
      data.entityIds = ids
      data.sign = Vue.prototype.FunGetSign(data)
      axios.get(Vue.prototype.global.Url_I18nBatchList, { params: data })
        .then(function(response) {
          if (response.data.code === 1) {
            that.translationMap = response.data.data || {}
          }
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    GvNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.parentId = that.selectParentId
      data.type = that.gvtype
      data.name = that.name
      data.gv = that.gv
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_GvNum, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    GvUpdate: function (pType) {
      var that = this
      var loading = that.$loading({ lock: true, text: '保存中...', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.editForm.id
      data.type = that.editForm.type
      data.name = that.editForm.name
      data.gv = that.editForm.gv
      if(pType == 2){
        data.gv = that.ueditorContent
      }
      data.gv2 = that.editForm.gv2
      if (that.editForm.gv3) {
        data.gv3 = that.editForm.gv3
      }
      data.note = that.editForm.note
      data.sortOrder = that.editForm.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_GvUpdate, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            Vue.prototype.$message.success('操作成功')
            that.dialogEdit = false
            that.GvList()
            that.GvNum()
            that.refreshGvCache()
          } else {
            Vue.prototype.FunRemindAllways(response.data.msg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
        .finally(function () {
          loading.close()
        })
    },
    GvInsert: function () {
      var that = this
      // 必填校验
      if (!that.addForm.type || that.addForm.type.trim() === '') {
        Vue.prototype.FunRemindAllways('请输入字典分类')
        return
      }
      if (!that.addForm.name || that.addForm.name.trim() === '') {
        Vue.prototype.FunRemindAllways('请输入字典名称')
        return
      }
      if (!that.addForm.gv || that.addForm.gv.trim() === '') {
        Vue.prototype.FunRemindAllways('请输入字典数据主')
        return
      }
      that.addLoading = true
      var data = Vue.prototype.FunGetBaseSignData()
      data.type = that.addForm.type
      data.name = that.addForm.name
      data.gv = that.addForm.gv
      data.gv2 = that.addForm.gv2
      if (that.addForm.gv3) {
        data.gv3 = that.addForm.gv3
      }
      data.note = that.addForm.note
      data.sign = Vue.prototype.FunGetSign(data)
      var loading = that.$loading({ lock: true, text: '提交中...', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
      axios.post(Vue.prototype.global.Url_GvAdd, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            Vue.prototype.$message.success('操作成功')
            that.dialogAdd = false
            that.GvList()
            that.GvNum()
            that.refreshGvCache()
          } else {
            Vue.prototype.FunRemindAllways(response.data.msg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
        .finally(function () {
          loading.close()
        })
    },
    clickDelete (row) {
      var that = this
      this.$confirm('确定删除该字典项吗？删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var data = Vue.prototype.FunGetBaseSignData()
        data.id = row.id
        data.sign = Vue.prototype.FunGetSign(data)
        axios.post(Vue.prototype.global.Url_GvDelete, Qs.stringify(data))
          .then(function (response) {
            if (response.data.code === 1) {
              Vue.prototype.$message.success('删除成功')
              that.GvList()
              that.GvNum()
              that.refreshGvCache()
            } else {
              Vue.prototype.FunRemindAllways(response.data.msg)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }).catch(function () {
        // 用户取消删除
      })
    },
    clickMoveUp (index, row) {
      if (index === 0) {
        Vue.prototype.FunRemindAllways('已经是第一条了')
        return
      }
      var that = this
      var prevRow = that.dataList[index - 1]
      var data = Vue.prototype.FunGetBaseSignData()
      var newCurrentSortOrder = prevRow.sortOrder
      var newPrevSortOrder = row.sortOrder
      // 当排序号相同时，确保交换后有差异
      if (newCurrentSortOrder === newPrevSortOrder) {
        newCurrentSortOrder = prevRow.sortOrder - 1
      }
      data['sortList[0].id'] = row.id
      data['sortList[0].sortOrder'] = newCurrentSortOrder
      data['sortList[1].id'] = prevRow.id
      data['sortList[1].sortOrder'] = newPrevSortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_GvUpdateSort, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            Vue.prototype.$message.success('操作成功')
            that.GvList()
            that.refreshGvCache()
          } else {
            Vue.prototype.FunRemindAllways(response.data.msg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    clickMoveDown (index, row) {
      if (index === this.dataList.length - 1) {
        Vue.prototype.FunRemindAllways('已经是最后一条了')
        return
      }
      var that = this
      var nextRow = that.dataList[index + 1]
      var data = Vue.prototype.FunGetBaseSignData()
      var newCurrentSortOrder = nextRow.sortOrder
      var newNextSortOrder = row.sortOrder
      // 当排序号相同时，确保交换后有差异
      if (newCurrentSortOrder === newNextSortOrder) {
        newCurrentSortOrder = nextRow.sortOrder + 1
      }
      data['sortList[0].id'] = row.id
      data['sortList[0].sortOrder'] = newCurrentSortOrder
      data['sortList[1].id'] = nextRow.id
      data['sortList[1].sortOrder'] = newNextSortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_GvUpdateSort, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            Vue.prototype.$message.success('操作成功')
            that.GvList()
            that.refreshGvCache()
          } else {
            Vue.prototype.FunRemindAllways(response.data.msg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    refreshGvCache: function () {
      var data = Vue.prototype.FunGetBaseSignData()
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_GvRefreshCache, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            var cacheData = response.data.data
            localStorage.setItem('aptustwoGvListActionType', JSON.stringify(cacheData.aptustwoGvListActionType))
            localStorage.setItem('aptustwoGvListBodyType', JSON.stringify(cacheData.aptustwoGvListBodyType))
            localStorage.setItem('aptustwoGvListMuscleRoup', JSON.stringify(cacheData.aptustwoGvListMuscleRoup))
            localStorage.setItem('aptustwoGvListAccessories', JSON.stringify(cacheData.aptustwoGvListAccessories))
            localStorage.setItem('aptustwoGvListUseLocation', JSON.stringify(cacheData.aptustwoGvListUseLocation))
            localStorage.setItem('aptustwoGvListCourseType', JSON.stringify(cacheData.aptustwoGvListCourseType))
            localStorage.setItem('aptustwoGvListCourseDifficulty', JSON.stringify(cacheData.aptustwoGvListCourseDifficulty))
            localStorage.setItem('aptustwoGvListCourseTimeType', JSON.stringify(cacheData.aptustwoGvListCourseTimeType))
            localStorage.setItem('aptustwoGvListTrainPlanClassification', JSON.stringify(cacheData.aptustwoGvListTrainPlanClassification))
            localStorage.setItem('aptustwoGvListTrainPlanType', JSON.stringify(cacheData.aptustwoGvListTrainPlanType))
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.main .main_l{
  width: 380px;
  flex-shrink: 0;
  border-right: 1px solid #e6e6e6;
}
.search {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .el-input {
    width: 300px;
    margin-right: 15px;
  }

  .el-select{
    margin-right: 15px;
  }

}

@media ( max-width: 1440px) {
  .search {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-input {
      width: 200px;
      margin-right: 15px;
    }

    .el-select{
      margin-right: 15px;
      width: 110px;
    }
  }
}

// 表格头部背景色
/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th, .el-table tr {
  background: #eff3ff;
}

/deep/ .el-table__expand-icon {
  display: none;
}

/deep/ .el-table .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-form-item {
  margin-bottom: 16px;
}

.organization_code{
  width: 127px;
  margin-right: 12px;
}

// 新增组织架构
.add_organization{
  padding-right: 15px;

  .organization_code{
    width: 157px;
    margin-right: 12px;
  }
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;

      & em{
        font-style: normal;
        color: #4976ff;
      }
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.sgdInfo{
  padding-left: 20px;
}

.tableOut{
  margin-top: 15px;

  // 圆角处理
  /deep/ thead tr th:nth-child(1) {
    border-radius: 10px 0 0 0;
  }
  /deep/ thead tr th:nth-last-child(2) {
    border-radius: 0 10px 0 0;
  }
}

// 内表格
.tableInner{
  margin-top: 20px;

  ::-webkit-scrollbar{
    width: 6px;  /*滚动条宽度*/
    height: 6px;  /*滚动条高度*/
  }

  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb{
    border-radius: 3px;
    background-color: #4976ff;  /*滚动条的背景颜色*/
  }

  // 圆角处理
  /deep/ thead tr th:nth-child(1) {
    border-radius: 10px 0 0 0;
  }
  /deep/ thead tr th:last-child {
    border-radius: 0 10px 0 0;
  }
}

.addUser_body{
  padding: 15px 40px 0 30px;
}

/deep/ .el-table__expanded-cell {
  padding: 20px 0px 0px 0px;
  margin: 15px;
  border: 1px solid #4976ff;
  border-radius: 10px;
  overflow: hidden;
}

.position{
  overflow: hidden;
  height: 433px;
  background: #f7f7f7;
}

// 弹出框
/deep/ .el-dialog__body {
  padding: 20px;
}

.newAdd /deep/ .el-dialog {
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  margin-top: 10vh !important;
}

.newAdd /deep/ .el-dialog__body {
  padding: 20px;
  overflow-y: auto;
  flex: 1;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  background: #f6f6fa;
  flex-shrink: 0;
}

.confirmDel /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.confirmDel /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.confirmDel /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.confirmMsg{
  padding: 10px 0 10px 0;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;

  & em{
    font-style: normal;
    margin-right: 10px;
    padding: 2px 6px;
    background: #f6f6fa;
    border-radius: 4px;
  }
}

.tree_txt{
  padding: 2px 6px;
  margin-right: 10px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
}

.tree_btn{
  margin-right: 5px;
}

.blue{
  color: #4976ff;
}

/deep/ .el-tree-node__content {
  height: 36px;
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}
/deep/ .el-tree-node__expand-icon {
    color: #4976ff;
  }
/deep/ .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  color: #4976ff;
  background-color: #fff;
}
/deep/ .el-tree-node__content:hover {
  color: #4976ff;
  background-color: #fff;
}

// /deep/ .custom-tree-node {
//   padding-right: 0px;
// }

// 组织架构
/deep/ .custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-right: 8px;
}

.tree_add_btn{
  margin-right: 5px;
}

.detailText {
  min-height: 40px;
  line-height: 22px;
  padding: 9px 15px;
  color: #606266;
  background: #f5f7fa;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
  word-break: break-all;
}

.detailTextArea {
  white-space: pre-wrap;
}
</style>
